import { useState, useEffect } from 'react'

import history from '../../../routes/history'
import { Events } from '../../../FSM/shared/constants'
import { ServiceSend } from '../../../types/interface/fsm.interface'

interface HookAccept {
  loading: boolean
}

const useLogic = (send: ServiceSend): HookAccept => {
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    setLoading(false)

    // `replace`, not `push`: /custom-auth is a one-shot entry URL, and leaving it in the stack
    // lets browser Back remount this page and re-fire CUSTOM_AUTH_SUCCESS.
    history.replace('/') //FIXME: need to push to the right location
    send({ type: Events.CUSTOM_AUTH_SUCCESS })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return {
    loading,
  }
}
export default useLogic
